export default function Dashboard() {
    // Placeholder for future dashboard
    return (
        <div></div>
    )
}